import { InputLabel } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateTimePickerInput = ({
  inputLabel,
  startFromTimePickerValue,
  handleChange,
  disabled,
}: {
  inputLabel: string;
  startFromTimePickerValue: dayjs.Dayjs | null;
  handleChange: any;
  disabled?: boolean;
}) => {
  return (
    <div className="datetime-picker-input-container">
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
        <InputLabel
          className={`dropdown-input-select-label`}
          sx={{
            color: "#fff",
            "&.Mui-disabled": {
              color: "#627195",
            },
          }}
        >
          {inputLabel}
        </InputLabel>
        <TimePicker
          className={`datetime-picker-input`}
          ampm={false}
          value={startFromTimePickerValue}
          onChange={(newValue: any) =>
            newValue && handleChange(dayjs(newValue))
          }
          minutesStep={1}
          sx={{
            height: "100%",
            width: "100%",
            justifyContent: "flex-end",
            "& .MuiInputBase-root": {
              "& .MuiInputBase-input": {
                color: "#fff",
                "&.Mui-disabled": {
                  "-webkit-text-fill-color": "red !important",
                  color: "red !important",
                },
              },
              "&.Mui-disabled": {
                "& .MuiInputBase-input": {
                  "-webkit-text-fill-color": "#627195 !important",
                  color: "#627195 !important",
                },
              },
            },
            "& .MuiButtonBase-root": {
              color: "#fff",
              "&.Mui-disabled": {
                color: "#627195",
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "0px solid #fff",
            },
          }}
          slotProps={{
            field: { clearable: true, onClear: () => handleChange(null) },
          }}
          disabled={disabled}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DateTimePickerInput;
